// extracted by mini-css-extract-plugin
module.exports = {"content":"videoModal_content__2rUEv","instagram":"videoModal_instagram__2queD","dialog":"videoModal_dialog__2LIpj"};